
import { Chip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment-timezone';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../common/EnhancedTableHead';
import LinkRouter from '../../common/LinkRouter';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    latestChip: {
      marginLeft: 16
    }
  })
);

interface Props {
  versions: any[];
  accountId: string;
  region: string;
  paramSetName: string;
  onDelete: (version: string) => void;
}

const headRows: HeadRow[] = [
  { id: 'version', disablePadding: true, label: 'Version' },
  { id: 'timestamp', disablePadding: true, label: 'Created' },
  { id: 'actions', disablePadding: true, label: 'Actions', disableSorting: true }
];

function FaroParamSetRevisionsTab(props: Props) {
  const { versions, accountId, region, paramSetName, onDelete } = props;
  const classes = useStyles({});

  const [page, setPage] = React.useState(0);
  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<string>('timestamp');
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
  };

  const sortedRows = sortRows(versions || [], getSorting(order, orderBy));
  const latestVersion = versions.length ? versions[0].version : null;

  return (
    <div>
      <Table>
        <EnhancedTableHead
          order={order}
          orderBy={orderBy}
          fields={headRows}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => (
            <TableRow key={row.timestamp}>
              <TableCell>
                <LinkRouter variant="body1" to={`/faro/parameters/${accountId}/${region}/${paramSetName}?version=${row.version}`}>{row.version}</LinkRouter>
                {row.timestamp === latestVersion && <Chip className={classes.latestChip} label="Latest" size="small" variant="outlined" />}
              </TableCell>
              <TableCell>
                {moment(row.timestamp).fromNow()}
              </TableCell>
              <TableCell>
                <Tooltip title="Delete this version">
                  <IconButton edge="end" aria-label="delete" onClick={() => onDelete(row.version)}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={versions.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default FaroParamSetRevisionsTab;
